import axiosAPI from 'axios';

const isProdMode = true;
const prodEndPoint = process.env.REACT_APP_99GIFT_ENDPOINT || 'https://api2.99gift.in/api/v6/';
const developmentEndPoint = `http://192.168.1.12:8000/api/v6/`;

const axios = axiosAPI.create({
  baseURL: isProdMode ? prodEndPoint : developmentEndPoint,
});

export { axios };
